// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__pDKSp","image":"Header_image__3GPKI","name":"Header_name__1Qv9R","info":"Header_info__14xxI","infoRow":"Header_infoRow__j0Sn8"};